import {
  DollarOutlined,
  FileProtectOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Space,
  Switch,
  Table,
  Tooltip,
  Typography,
  message
} from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import CurrencyInputCustom from '../../components/CurrencyInputCustom';
import {
  InputIconAutorizar,
  InputIconCobertura,
  InputIconCostoAdicional,
  InputIconCostoMinimo,
  InputIconEdit,
  InputIconEliminar,
  InputIconRecargo
} from '../../components/InputIcons';
import MapPolygon from '../../components/MapPolygon';
import MonedaSelector from '../../components/MonedaSelector';
import SelectableListModalCoberturas from '../../components/SelectableListModalCoberturas';

import {
  CONFIG,
  TIPOS_COMBUSTIBLE,
  TIPOS_USO_VEHICULO_TODOS,
  TIPOS_VEHICULO
} from '../../constants';
import {
  getCoberturaLabel,
  getCostoLabel
} from '../../functions/opcionesSubcobertura';
import { currencyToNumber, getDescripcionOpcion } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';
import FranquiciaPorRangos from '../aseguradora/FranquiciaPorRangos';

const { Option } = Select;

const VehiculoFormModal = ({
  columnName = '',
  title,
  initialValues,
  setControlProducto,
  tipoButton = 'editar',
  setLoading,
  monedaList,
  loading
}) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [anios, setAnios] = useState([]);
  const [antiguedadSelected, setAntiguedadSelected] = useState();
  const [volanteCambiado, setVolanteCambiado] = useState();
  const [autorizar, setAutorizar] = useState();
  const [submodelos, setSubmodelos] = useState([]);
  const [moneda, setMoneda] = useState();

  const showModal = () => {
    if (
      columnName === 'marca' ||
      columnName === 'modelo' ||
      columnName === 'submodelo'
    ) {
      getMarcas();
    }
    setIsModalOpen(true);
  };

  const handleOk = () => {
    const values = form.getFieldsValue();
    let newValues = {};
    if (columnName === 'marca' && values.marca.id !== initialValues.id_marca) {
      const marcaSelected = marcas.find((item) => item.id === values.marca.id);
      newValues = {
        id_marca: values.marca.id,
        marca: marcaSelected,
        id_modelo: null,
        modelo: null,
        id_submodelo: null,
        submodelo: null,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'modelo' &&
      values.id_modelo !== initialValues.id_modelo
    ) {
      newValues = {
        id_marca: values.marca.id,
        marca: marcas.find((item) => item.id === values.marca.id),
        id_modelo: values.modelo.id,
        modelo: modelos.find((item) => item.id === values.modelo.id),
        id_submodelo: null,
        submodelo: null,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'submodelo' &&
      ((initialValues.id_submodelo &&
        values.id_submodelo !== initialValues.id_submodelo) ||
        !initialValues.id_submodelo)
    ) {
      newValues = {
        id_marca: values.marca.id,
        marca: marcas.find((item) => item.id === values.marca.id),
        id_modelo: values.modelo.id,
        modelo: modelos.find((item) => item.id === values.modelo.id),
        id_submodelo: values.submodelo.id,
        submodelo: submodelos.find((item) => item.id === values.submodelo.id),
        editado: !!initialValues.id
      };
    } else if (columnName === 'anho') {
      if (antiguedadSelected) {
        newValues = {
          cantidad_anho_antiguedad: values.cantidad_anho_antiguedad,
          anho_desde: null,
          anho_hasta: null,
          editado: !!initialValues.id
        };
      } else {
        if (
          values.anho_desde &&
          values.anho_hasta &&
          values.anho_desde > values.anho_hasta
        ) {
          message.warning('Verificar rango de años');
          return;
        }
        newValues = {
          anho_desde: values.anho_desde,
          anho_hasta: values.anho_hasta,
          cantidad_anho_antiguedad: null,
          editado: !!initialValues.id
        };
      }
    } else if (columnName === 'combustible') {
      newValues = {
        tipo_combustible: values.tipo_combustible,
        editado: !!initialValues.id
      };
    } else if (columnName === 'volante_cambiado') {
      newValues = {
        volante_cambiado: volanteCambiado,
        editado: !!initialValues.id
      };
    } else if (columnName === 'tipo_vehiculo') {
      newValues = {
        tipo_vehiculo: values.tipo_vehiculo,
        editado: !!initialValues.id
      };
    } else if (columnName === 'tipo_uso') {
      newValues = {
        tipo_uso: values.tipo_uso,
        editado: !!initialValues.id
      };
    } else if (columnName === 'ocupantes') {
      newValues = {
        ocupantes: values.ocupantes,
        editado: !!initialValues.id
      };
    } else if (columnName === 'autorizacion') {
      newValues = {
        autorizacion: autorizar,
        editado: !!initialValues.id
      };
    } else if (columnName === 'recargo') {
      newValues = {
        recargo: values.recargo,
        editado: !!initialValues.id
      };
    } else if (columnName === 'costo_adicional_ocupantes') {
      newValues = {
        costo_adicional_ocupantes: values.costo_adicional_ocupantes,
        editado: !!initialValues.id
      };
    } else if (columnName === 'costo_minimo') {
      newValues = {
        costo_minimo: values.costo_minimo,
        editado: !!initialValues.id
      };
    } else if (columnName === 'eliminar') {
      newValues = {
        eliminado: true
      };
    }
    const newControlProducto = {
      ...initialValues,
      ...newValues
    };
    form.setFieldsValue(newControlProducto);
    setControlProducto(newControlProducto);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };
  const clearAll = () => {};

  async function getMarcas() {
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
    } catch (error) {
      // error
    }
  }

  async function getModelos() {
    try {
      const marca = form && form.getFieldValue('marca');
      if (marca && marca.id) {
        const response = await instanceRef.instance.get(
          `data/modelos?marca=${marca.id}`
        );
        const orderedModelos = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            })
          : [];

        setModelos(orderedModelos);
      }
    } catch (error) {
      // error
    }
  }

  async function getAnios() {
    try {
      const currentYear = Number(new Date().getFullYear() + 1);
      const firstYear = Number(1990);
      const aniosList = [null];

      for (let i = firstYear; i < currentYear; i += 1) {
        aniosList.push(i);
      }

      const orderedAnios = aniosList.sort(function test(a, b) {
        if (a < b) {
          return 1;
        }
        if (a > b) {
          return -1;
        }
        return 0;
      });

      setAnios(orderedAnios);
    } catch (error) {
      // error
    }
  }

  async function getSubmodelos(modelo) {
    try {
      // setLoading(true);
      const response = await instanceRef.instance.get(
        `data/submodelos/modelo`,
        {
          params: { modelo }
        }
      );
      const orderedSubmodelos = response.data.data
        ? response.data.data.sort(function test(a, b) {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          })
        : [];
      setSubmodelos(orderedSubmodelos);
    } catch (error) {
      // error
    }
    setLoading(false);
  }

  useEffect(() => {
    if (modelos && form && modelos.length > 0) {
      const values = form.getFieldsValue();
      if (values?.modelo?.id) {
        getSubmodelos(values.modelo.id);
      } else if (initialValues && initialValues.modelo) {
        getSubmodelos(initialValues.modelo.id);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelos, form]);

  useEffect(() => {
    if (marcas && form.getFieldValue('marca')) {
      getModelos();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marcas, form]);

  useEffect(() => {
    if (initialValues && !initialValues.eliminado) {
      const values = {
        ...initialValues,
        opcion_ingresar_anho: initialValues.cantidad_anho_antiguedad
          ? 'antiguedad'
          : 'anho'
      };
      form.setFieldsValue(values);
      setAntiguedadSelected(!!initialValues.cantidad_anho_antiguedad);
      setVolanteCambiado(initialValues.volante_cambiado);
      setAutorizar(initialValues.autorizacion);
    }

    if (columnName === 'anho') {
      getAnios();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initialValues && !initialValues.eliminado) {
      form.setFieldsValue(initialValues);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  useEffect(() => {
    if (monedaList) {
      setMoneda(monedaList[0]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monedaList]);
  return (
    <>
      {tipoButton === 'editar' && <InputIconEdit onClick={showModal} />}
      {tipoButton === 'autorizacion' && (
        <InputIconAutorizar onClick={showModal} active={autorizar} />
      )}
      {tipoButton === 'recargo' && (
        <InputIconRecargo onClick={showModal} active={initialValues.recargo} />
      )}
      {tipoButton === 'costo_adicional_ocupantes' && (
        <InputIconCostoAdicional
          onClick={showModal}
          active={initialValues.costo_adicional_ocupantes}
        />
      )}
      {tipoButton === 'costo_minimo' && (
        <InputIconCostoMinimo
          onClick={showModal}
          active={initialValues.costo_minimo}
        />
      )}
      {tipoButton === 'cobertura' && (
        <InputIconCobertura
          onClick={showModal}
          active={initialValues?.cPC?.length > 0}
        />
      )}
      {tipoButton === 'eliminar' && <InputIconEliminar onClick={showModal} />}

      <Modal
        // eslint-disable-next-line react/destructuring-assignment
        title={`${
          (initialValues && !initialValues.id) || columnName === 'eliminar'
            ? ''
            : 'Editar'
        } ${title}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={700}
        okText={columnName === 'eliminar' && 'Si'}
        cancelText={columnName === 'eliminar' && 'No'}
      >
        {moneda && (
          <div
            style={{
              marginBottom: '4%',
              marginTop: '4%'
            }}
          >
            <MonedaSelector
              value={moneda.codigo}
              monedas={monedaList}
              loading={loading}
              onChange={(e) => {
                setMoneda(
                  monedaList.find((item) => item.codigo === e.target.value)
                );
              }}
            />
          </div>
        )}
        <Form
          name="controlProductoVehiculo"
          initialValues={initialValues}
          wrapperCol={{ span: 16 }}
          autoComplete="off"
          form={form}
        >
          {columnName === 'marca' && (
            <Form.Item
              label="Marca"
              name={['marca', 'id']}
              rules={[{ required: true }]}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
              >
                {marcas.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {columnName === 'modelo' && (
            <>
              {modelos.length > 0 && (
                <>
                  <Form.Item
                    label="Marca"
                    name={['marca', 'id']}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      onChange={(value) => {
                        form.setFieldsValue({
                          id_marca: value,
                          id_modelo: null,
                          id_submodelo: null
                        });
                        getModelos();
                      }}
                      // disabled
                    >
                      {marcas.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Modelo" name={['modelo', 'id']}>
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Elegir modelo"
                      onChange={(value) => {
                        form.setFieldsValue({
                          id_modelo: value,
                          id_submodelo: null
                        });
                        getSubmodelos(value);
                      }}
                    >
                      {modelos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              )}
            </>
          )}

          {columnName === 'submodelo' && (
            <>
              <Form.Item
                label="Marca"
                name={['marca', 'id']}
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  optionFilterProp="children"
                  onChange={(value) => {
                    form.setFieldsValue({
                      id_marca: value,
                      id_modelo: null,
                      id_submodelo: null
                    });
                    getModelos();
                  }}
                >
                  {marcas.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <>
                {modelos && (
                  <Form.Item
                    label="Modelo"
                    name={['modelo', 'id']}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Elegir modelo"
                      onChange={(value) => {
                        form.setFieldsValue({
                          // id_marca: value,
                          id_modelo: value,
                          id_submodelo: null
                        });
                        getSubmodelos(value);
                      }}
                    >
                      {modelos.length > 0 &&
                        modelos.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.descripcion}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
                {submodelos && (
                  <Form.Item
                    label="Submodelo"
                    name={['submodelo', 'id']}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Elegir submodelo"
                    >
                      {submodelos.length > 0 &&
                        submodelos.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.descripcion}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
              </>
            </>
          )}

          {columnName === 'anho' && (
            <Form.Item
              label="Configurar por"
              name={['opcion_ingresar_anho']}
              onChange={(e) => {
                if (e.target.value === 'antiguedad') {
                  setAntiguedadSelected(true);
                } else {
                  setAntiguedadSelected(false);
                }
              }}
            >
              <Radio.Group>
                <Space>
                  <Radio value="anho">Rango de Años</Radio>
                  <Radio value="antiguedad">Antigüedad</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          )}

          {columnName === 'anho' && !antiguedadSelected && (
            <>
              <Form.Item label="Desde" name="anho_desde">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir Año"
                >
                  {anios.map((item) => (
                    <Option key={item} value={item}>
                      {`${item || ''}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Hasta" name="anho_hasta">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir Año"
                >
                  {anios.map((item) => (
                    <Option key={item} value={item}>
                      {`${item || ''}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}

          {columnName === 'anho' && antiguedadSelected && (
            <>
              <Form.Item
                label="Antigüedad máxima en años"
                name="cantidad_anho_antiguedad"
              >
                <InputNumber min={1} />
              </Form.Item>
            </>
          )}
          {columnName === 'combustible' && (
            <Form.Item label="Combustible" name={['tipo_combustible']}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder="Elegir"
              >
                {TIPOS_COMBUSTIBLE.map((item) => (
                  <Option key={item.codigo} value={item.codigo}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {columnName === 'volante_cambiado' && (
            <Form.Item label="Volante Cambiado" valuePropName="checked">
              <Switch
                checkedChildren="Si"
                unCheckedChildren="No"
                checked={volanteCambiado}
                onChange={(value) => setVolanteCambiado(!!value)}
              />
            </Form.Item>
          )}

          {columnName === 'tipo_vehiculo' && (
            <Form.Item label="Tipo" name={['tipo_vehiculo']}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder="Elegir"
              >
                {TIPOS_VEHICULO.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {columnName === 'tipo_uso' && (
            <>
              <Form.Item label="Tipo de Uso" name={['tipo_uso']}>
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.codigo.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir"
                >
                  {TIPOS_USO_VEHICULO_TODOS.map(
                    (item) =>
                      item.codigo !== 'OTROS' && (
                        <Option key={item.codigo} value={item.codigo}>
                          {item.codigo}
                        </Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </>
          )}
          {columnName === 'ocupantes' && (
            <>
              <Form.Item label="Cantidad de Ocupantes" name="ocupantes">
                <InputNumber min={1} />
              </Form.Item>
            </>
          )}
          {columnName === 'autorizacion' && (
            <Form.Item
              label="¿Desea que se realice una Autorización?"
              valuePropName="checked"
            >
              <Switch
                checkedChildren="Si"
                unCheckedChildren="No"
                checked={autorizar}
                onChange={(value) => setAutorizar(!!value)}
              />
            </Form.Item>
          )}

          {columnName === 'recargo' && (
            <Form.Item
              label="Porcentaje de Recargo"
              name="recargo"
              normalize={(value) => {
                if (Number(value) > 100) {
                  return 100;
                }
                if (Number(value) < 0) {
                  return 0;
                }
                return Number(value);
              }}
            >
              <Input
                min={0}
                max={100}
                step={0.1}
                placeholder="0"
                type="number"
                suffix="%"
                prop
                style={{ width: 100, textAlign: 'end' }}
              />
            </Form.Item>
          )}

          {columnName === 'costo_adicional_ocupantes' && (
            <Form.Item
              label="Costo Adicional por Ocupante"
              name="costo_adicional_ocupantes"
              normalize={(value) => currencyToNumber(value, moneda)}
              style={{ width: 'fit-content' }}
            >
              <CurrencyInputCustom moneda={moneda} bordered />
            </Form.Item>
          )}

          {columnName === 'costo_minimo' && (
            <Form.Item
              label="Costo Mínimo"
              name="costo_minimo"
              normalize={(value) => currencyToNumber(value, moneda)}
              style={{ width: 'fit-content' }}
            >
              <CurrencyInputCustom moneda={moneda} bordered />
            </Form.Item>
          )}

          {columnName === 'eliminar' && (
            <p>
              ¿Está seguro? Se eliminará toda la información del Control
              Producto
            </p>
          )}
        </Form>
      </Modal>
    </>
  );
};

const ZonaFormModal = ({
  columnName = '',
  formName,
  title,
  initialValues,
  setControlProducto,
  tipoButton = 'editar'
}) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [autorizar, setAutorizar] = useState();
  const [points, setPoints] = useState();

  const showModal = () => {
    if (columnName === 'departamento' || columnName === 'distrito') {
      getDepartamentos();
    }
    if (columnName === 'zona') {
      const coordZonaList = initialValues.poligono?.coordinates[0];
      const pointList = [];
      if (coordZonaList) {
        coordZonaList.map((item) =>
          pointList.push({ lat: item[0], lng: item[1] })
        );
        setPoints(pointList);
      }
    }
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    const values = form.getFieldsValue();
    let newValues = {};
    if (
      columnName === 'departamento' &&
      values.departamento.id !== initialValues.id_departamento
    ) {
      const departamentoSelected = departamentos.find(
        (item) => item.id === values.departamento.id
      );
      newValues = {
        id_departamento: values.departamento.id,
        departamento: departamentoSelected,
        id_distrito: null,
        distrito: null,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'distrito' &&
      values.distrito.id !== initialValues.id_distrito
    ) {
      newValues = {
        id_departamento: values.departamento.id,
        departamento: departamentos.find(
          (item) => item.id === values.departamento.id
        ),
        id_distrito: values.distrito.id,
        distrito: distritos.find((item) => item.id === values.distrito.id),
        editado: !!initialValues.id
      };
    } else if (columnName === 'zona') {
      try {
        await form.validateFields();
      } catch (err) {
        return;
      }
      if (!points) {
        message.warning('Debe ubicar la zona en el mapa');
        return;
      }
      const listTotal = [];
      const pointsActualizados = [...points];
      pointsActualizados.forEach((item) => {
        listTotal.push([item.lat, item.lng]);
      });

      newValues = {
        editado: !!initialValues.id,

        descripcion_poligono: values.descripcion_poligono,
        poligono: {
          type: 'Polygon',
          coordinates: [listTotal]
        }
      };
    } else if (columnName === 'autorizacion') {
      newValues = {
        autorizacion: autorizar,
        editado: !!initialValues.id
      };
    } else if (columnName === 'recargo') {
      newValues = {
        recargo: values.recargo,
        editado: !!initialValues.id
      };
    } else if (columnName === 'eliminar') {
      newValues = {
        eliminado: true
      };
    }
    const newControlProducto = {
      ...initialValues,
      ...newValues
    };
    form.setFieldsValue(newControlProducto);
    setControlProducto(newControlProducto);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };
  const clearAll = () => {};

  async function getDepartamentos() {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);
      // getDistritos(fields?.id_departamento);
    } catch (error) {
      // error
    }
  }

  async function getDistritos() {
    try {
      const departamento = form.getFieldValue('departamento');
      if (departamento && departamento.id) {
        const response = await instanceRef.instance.get(
          `data/distritos?departamento=${departamento.id}`
        );
        const orderedDistritos = response.data.data.sort(function test(a, b) {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });
        setDistritos(orderedDistritos);
      }
    } catch (error) {
      // error
    }
  }

  useEffect(() => {
    if (departamentos) {
      getDistritos();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departamentos]);

  useEffect(() => {
    if (initialValues && !initialValues.eliminado) {
      const values = {
        ...initialValues
      };
      form.setFieldsValue(values);
      setAutorizar(values.autorizacion);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initialValues && !initialValues.eliminado) {
      form.setFieldsValue(initialValues);
      setAutorizar(initialValues.autorizacion);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);
  return (
    <>
      {tipoButton === 'editar' && <InputIconEdit onClick={showModal} />}
      {tipoButton === 'autorizacion' && (
        <InputIconAutorizar onClick={showModal} active={autorizar} />
      )}
      {tipoButton === 'recargo' && (
        <InputIconRecargo onClick={showModal} active={initialValues.recargo} />
      )}
      {tipoButton === 'cobertura' && (
        <InputIconCobertura
          onClick={showModal}
          active={initialValues?.cPC?.length > 0}
        />
      )}
      {tipoButton === 'eliminar' && <InputIconEliminar onClick={showModal} />}

      <Modal
        // eslint-disable-next-line react/destructuring-assignment
        title={`${
          (initialValues && !initialValues.id) || columnName === 'eliminar'
            ? ''
            : 'Editar'
        } ${title}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={columnName === 'zona' ? 1000 : 700}
        okText={columnName === 'eliminar' && 'Si'}
        cancelText={columnName === 'eliminar' && 'No'}
      >
        <>
          <Form
            name={`controlProductoZona-${formName}`}
            initialValues={initialValues}
            wrapperCol={{ span: 16 }}
            autoComplete="off"
            form={form}
          >
            {(columnName === 'departamento' || columnName === 'distrito') && (
              <Col xs={24} md={24} align="start">
                <Form.Item
                  label="Departamento"
                  name={['departamento', 'id']}
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    /* disabled={
                      initialValues &&
                      initialValues.id_departamento &&
                      columnName === 'distrito'
                    } */
                    onChange={(value) => {
                      form.setFieldsValue({
                        id_departamento: value,
                        id_distrito: null
                      });
                      getDistritos();
                    }}
                  >
                    {departamentos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.descripcion}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
            {columnName === 'distrito' && (
              <Col xs={24} md={24} align="start">
                <Form.Item
                  label="Ciudad"
                  name={['distrito', 'id']}
                  rules={[{ required: true }]}
                >
                  <Select
                    // labelInValue
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                    placeholder="Elegir ciudad"
                  >
                    {distritos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.descripcion}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}

            {columnName === 'zona' && (
              <Form.Item
                label="Descripción"
                name="descripcion_poligono"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            )}

            {columnName === 'autorizacion' && (
              <Form.Item
                label="¿Desea que se realice una Autorización?"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="Si"
                  unCheckedChildren="No"
                  checked={autorizar}
                  onChange={(value) => setAutorizar(!!value)}
                />
              </Form.Item>
            )}

            {columnName === 'recargo' && (
              <Form.Item
                label="Porcentaje de Recargo"
                name="recargo"
                normalize={(value) => {
                  if (Number(value) > 100) {
                    return 100;
                  }
                  if (Number(value) < 0) {
                    return 0;
                  }
                  return Number(value);
                }}
              >
                <Input
                  min={0}
                  max={100}
                  step={0.1}
                  placeholder="0"
                  type="number"
                  suffix="%"
                  style={{ width: 100, textAlign: 'end' }}
                />
              </Form.Item>
            )}

            {columnName === 'eliminar' && (
              <p>
                ¿Está seguro? Se eliminará toda la información del Control
                Producto
              </p>
            )}
          </Form>

          {columnName === 'zona' && <MapPolygon {...{ points, setPoints }} />}
        </>
      </Modal>
    </>
  );
};

const ControlProductoList = ({
  tipoValidacion,
  list,
  setList,
  idAutorizacionConfig,
  idAseguradora,
  idProducto,
  loading,
  setLoading,
  mostrarAcciones = true,
  controlProductoEliminadoList,
  setControlProductoEliminadoList,
  columns,
  dataSourceTable,
  handleAddRow,
  producto
}) => {
  const [controlProductoList, setControlProductoList] = useState([]);
  const [controlProducto, setControlProducto] = useState();
  const [, setControlProductoCoberturas] = useState([]);
  const [monedaList, setMonedaList] = useState(null);
  const [openFranquiciaRangos, setOpenFranquiciaRangos] = useState(false);
  const [franquiciasModel, setFranquiciasModel] = useState();

  const columnsVehiculo = [
    {
      title: 'Marca',
      key: 'marca',
      align: 'right',
      render: (record) => {
        const { marca } = record;
        return (
          <Space>
            {(marca && marca.descripcion) || ''}
            <VehiculoFormModal
              columnName="marca"
              title="Marca"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Modelo',
      key: 'modelo',
      align: 'right',
      render: (record) => {
        const { modelo } = record;
        return (
          <Space>
            {(modelo && modelo.descripcion) || ''}
            <VehiculoFormModal
              columnName="modelo"
              title="Modelo"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Submodelo',
      key: 'submodelo',
      align: 'right',
      render: (record) => {
        const { submodelo } = record;
        return (
          <Space>
            {(submodelo && submodelo.descripcion) || ''}
            <VehiculoFormModal
              columnName="submodelo"
              title="Submodelo"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Año',
      key: 'anho',
      align: 'right',
      render: (record) => {
        const { anho_desde, anho_hasta, cantidad_anho_antiguedad } = record;
        let anho =
          anho_desde || anho_hasta
            ? `[${anho_desde || 'Sin definir'} - ${
                anho_hasta || 'Sin definir'
              }]`
            : '';
        if (cantidad_anho_antiguedad) {
          anho = cantidad_anho_antiguedad;
        }
        return (
          <Space>
            {(
              <Typography.Text style={{ whiteSpace: 'nowrap' }}>
                {anho}
              </Typography.Text>
            ) || ''}
            <VehiculoFormModal
              columnName="anho"
              title="Rango de años / Antigüedad"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Combustible',
      key: 'tipo_combustible',
      align: 'right',
      render: (record) => {
        const { tipo_combustible } = record;

        return (
          <Space>
            {tipo_combustible || ''}
            <VehiculoFormModal
              columnName="combustible"
              title="Combustible"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Volante Cambiado',
      key: 'volante_cambiado',
      align: 'right',
      render: (record) => {
        const { volante_cambiado } = record;
        let volanteCambiado = '';
        if (volante_cambiado !== null) {
          volanteCambiado = volante_cambiado ? 'Si' : 'No';
        }
        return (
          <Space>
            {volanteCambiado}
            <VehiculoFormModal
              columnName="volante_cambiado"
              title="Volante Cambiado"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Tipo',
      key: 'tipo_vehiculo',
      align: 'right',
      render: (record) => {
        const { tipo_vehiculo } = record;

        return (
          <Space>
            {tipo_vehiculo || ''}
            <VehiculoFormModal
              columnName="tipo_vehiculo"
              title="Tipo"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Tipo de Uso',
      key: 'tipo_uso',
      align: 'right',
      render: (record) => {
        const { tipo_uso } = record;

        return (
          <Space>
            {tipo_uso || ''}
            <VehiculoFormModal
              columnName="tipo_uso"
              title="Tipo de Uso"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Cantidad Máxima de Ocupantes',
      key: 'ocupantes',
      align: 'right',
      render: (record) => {
        const { ocupantes } = record;

        return (
          <Space>
            {ocupantes || ''}
            <VehiculoFormModal
              columnName="ocupantes"
              title="Cantidad Máxima de Ocupantes"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (record) => {
        const { cPC } = record;
        const tieneCoberturas =
          cPC?.length > 0 ? cPC.some((item) => item.subcobertura) : false;
        const tieneFranquicias =
          franquiciasModel && franquiciasModel.franquicias.length > 0;

        return (
          <Space>
            {mostrarAcciones && (
              <>
                <VehiculoFormModal
                  columnName="autorizacion"
                  title="Autorización"
                  initialValues={record}
                  {...{
                    setControlProducto,
                    setLoading
                  }}
                  tipoButton="autorizacion"
                />
                <VehiculoFormModal
                  columnName="recargo"
                  title="Recargo"
                  initialValues={record}
                  {...{
                    setControlProducto,
                    setLoading
                  }}
                  tipoButton="recargo"
                />
                <>
                  <FranquiciaPorRangos
                    open={openFranquiciaRangos}
                    onOk={(values) => {
                      handleChangeFranquicias(values, record);
                    }}
                    onCancel={() => setOpenFranquiciaRangos(false)}
                    model={franquiciasModel}
                    idAseguradora={idAseguradora}
                  />
                  <Tooltip title="Franquicia por rangos" key="franquicias">
                    <DollarOutlined
                      onClick={() => initializeFranquiciasModel(record)}
                      style={{
                        color: tieneFranquicias
                          ? CONFIG.COLOR_PRIMARY
                          : 'rgba(0,0,0,.45)'
                      }}
                    />
                  </Tooltip>
                </>
                <VehiculoFormModal
                  columnName="costo_adicional_ocupantes"
                  title="Costo Adicional por Ocupante"
                  initialValues={record}
                  {...{
                    setControlProducto,
                    monedaList,
                    loading,
                    setLoading
                  }}
                  tipoButton="costo_adicional_ocupantes"
                />
                <VehiculoFormModal
                  columnName="costo_minimo"
                  title="Costo Mínimo"
                  initialValues={record}
                  {...{
                    setControlProducto,
                    monedaList,
                    loading,
                    setLoading
                  }}
                  tipoButton="costo_minimo"
                />

                {idAseguradora && idProducto && (
                  <SelectableListModalCoberturas
                    title="Opciones de Coberturas"
                    iconButton={
                      <UnorderedListOutlined
                        style={{
                          color: tieneCoberturas
                            ? CONFIG.COLOR_PRIMARY
                            : 'rgba(0,0,0,.45)'
                        }}
                      />
                    }
                    controlProductoCoberturas={cPC}
                    setControlProductoCoberturas={setControlProductoCoberturas}
                    isMultiple
                    columnsData={columnsCobertura}
                    url={`/cobertura/search/subcobertura?idAseguradora=${idAseguradora}&idProducto=${idProducto}`}
                    width={1200}
                    idAseguradora={idAseguradora}
                    idProducto={idProducto}
                    data={record}
                    handleChange={handleChange}
                  />
                )}
                <Tooltip title="Eliminar" key="eliminar">
                  <VehiculoFormModal
                    columnName="eliminar"
                    title="Eliminar"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                    tipoButton="eliminar"
                  />
                </Tooltip>
              </>
            )}
          </Space>
        );
      }
    }
  ];
  const columnsZona = [
    {
      title: 'Departamento',
      key: 'departamento',
      align: 'right',
      render: (record) => {
        const { departamento, id, key } = record;
        const formName = `${id || key}-departamento`;
        return (
          <Space>
            {(departamento && departamento.descripcion) || ''}
            <ZonaFormModal
              columnName="departamento"
              formName={formName}
              title="Departamento"
              initialValues={record}
              {...{
                setControlProducto
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Ciudad',
      key: 'distrito',
      align: 'right',
      render: (record) => {
        const { distrito, id, key } = record;
        const formName = `${id || key}-distrito`;
        return (
          <Space>
            {(distrito && distrito.descripcion) || ''}
            <ZonaFormModal
              columnName="distrito"
              formName={formName}
              title="Ciudad"
              initialValues={record}
              {...{
                setControlProducto
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Zona',
      key: 'zona',
      align: 'right',
      render: (record) => {
        const { descripcion_poligono, id, key } = record;
        const formName = `${id || key}-zona`;
        return (
          <Space>
            {descripcion_poligono || ''}
            <ZonaFormModal
              columnName="zona"
              formName={formName}
              title="Zona"
              initialValues={record}
              {...{
                setControlProducto
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (record) => {
        const { cPC } = record;
        const tieneCoberturas =
          cPC?.length > 0 ? cPC.some((item) => item.subcobertura) : false;

        const { id, key } = record;
        const formNameAutorizacion = `${id || key}-autorizacion`;
        const formNameRecargo = `${id || key}-recargo`;
        const formNameEliminar = `${id || key}-eliminar`;
        const tieneFranquicias =
          franquiciasModel && franquiciasModel.franquicias.length > 0;
        return (
          <Space>
            {mostrarAcciones && (
              <>
                <ZonaFormModal
                  columnName="autorizacion"
                  formName={formNameAutorizacion}
                  title="Autorización"
                  initialValues={record}
                  {...{
                    setControlProducto
                  }}
                  tipoButton="autorizacion"
                />

                <ZonaFormModal
                  columnName="recargo"
                  formName={formNameRecargo}
                  title="Recargo"
                  initialValues={record}
                  {...{
                    setControlProducto
                  }}
                  tipoButton="recargo"
                />
                <>
                  <FranquiciaPorRangos
                    open={openFranquiciaRangos}
                    onOk={(values) => {
                      handleChangeFranquicias(values, record);
                    }}
                    onCancel={() => setOpenFranquiciaRangos(false)}
                    model={franquiciasModel}
                    idAseguradora={idAseguradora}
                  />
                  <Tooltip title="Franquicia por rangos" key="franquicias">
                    <DollarOutlined
                      onClick={() => initializeFranquiciasModel(record)}
                      style={{
                        color: tieneFranquicias
                          ? CONFIG.COLOR_PRIMARY
                          : 'rgba(0,0,0,.45)'
                      }}
                    />
                  </Tooltip>
                </>
                {idAseguradora && (
                  <SelectableListModalCoberturas
                    title="Opciones de Coberturas"
                    iconButton={
                      <UnorderedListOutlined
                        style={{
                          color: tieneCoberturas
                            ? CONFIG.COLOR_PRIMARY
                            : 'rgba(0,0,0,.45)'
                        }}
                      />
                    }
                    controlProductoCoberturas={cPC}
                    setControlProductoCoberturas={setControlProductoCoberturas}
                    isMultiple
                    columnsData={columnsCobertura}
                    url={`/cobertura/search/subcobertura?idAseguradora=${idAseguradora}&idProducto=${idProducto}`}
                    width={1200}
                    idAseguradora={idAseguradora}
                    idProducto={idProducto}
                    data={record}
                    handleChange={handleChange}
                  />
                )}
              </>
            )}

            <Tooltip title="Eliminar" key="eliminar">
              <ZonaFormModal
                formName={formNameEliminar}
                columnName="eliminar"
                title="Eliminar"
                initialValues={record}
                {...{
                  setControlProducto
                }}
                tipoButton="eliminar"
              />
            </Tooltip>
          </Space>
        );
      }
    }
  ];
  const columnsVehiculoZona =
    tipoValidacion === 'vehiculo' ? columnsVehiculo : columnsZona;

  const getMonedas = async () => {
    setLoading(true);
    const response = await instanceRef.instance.get(`/moneda`);
    setMonedaList(response.data.data);
    setLoading(false);
    return response.data.data;
  };

  const columnsCobertura = [
    {
      title: 'Subcobertura',
      render: (text, r) => {
        const coberturaObj = getCoberturaLabel(r);
        return `
            ${r.cobertura.descripcion} | Tipo: ${getDescripcionOpcion(
          r.opcion
        )} - Cobertura: ${coberturaObj ? coberturaObj.label : ''}
        ${getCostoLabel(r) ? ` - Costo: ${getCostoLabel(r)}` : ''}
        ${
          r.costo_min
            ? ` - Costo Mínimo: ${formatoMonedaGenerico(r.moneda, r.costo_min)}`
            : ''
        }
        ${
          r.costo_max
            ? ` - Costo Máximo: ${formatoMonedaGenerico(r.moneda, r.costo_max)}`
            : ''
        }
        - ${r.moneda.simbolo}
      `;
      }
    }
  ];

  const handleAdd = () => {
    // const newRow = count + 1;
    let newData = {};
    if (tipoValidacion === 'vehiculo') {
      newData = {
        // key: newRow,
        // row: newRow,
        key: `tipo-${Math.random().toString(36).substr(2, 9)}`,
        row: 1, // set row to 1
        marca: null,
        modelo: null,
        anho_desde: null,
        anho_hasta: null,
        combustible: null,
        volante_cambiado: null,
        tipo_vehiculo: null,
        tipo_uso: null,
        ocupantes: null,
        id_autorizacion_config: idAutorizacionConfig,
        coberturas: [],
        cPC: []
      };
    } else if (tipoValidacion === 'zona') {
      newData = {
        // key: newRow,
        // row: newRow,
        key: `tipo-${Math.random().toString(36).substr(2, 9)}`,
        row: 1, // set row to 1
        departamento: null,
        distrito: null,
        poligono: null,
        id_autorizacion_config: idAutorizacionConfig,
        coberturas: [],
        cPC: []
      };
    }

    const newControlProductoList = [
      newData,
      ...controlProductoList.slice(0, controlProductoList.length)
    ]; // add the new element to the beginning of the list and reorder the rest of the elements accordingly

    // loop through the newControlProductoList array and update the row and key values of the existing elements
    for (let i = 0; i < newControlProductoList.length; i += 1) {
      newControlProductoList[i].row = i + 1;
    }

    setControlProductoList(newControlProductoList);

    // setCount(count + 1);
  };

  const handleChange = (updatedCoberturasList, data) => {
    const toUpdateControlProducto = data;
    /* const idList = updatedCoberturasList.map((item) => item.id_cobertura);
    console.log('idList', idList);
    const newList = cPC.filter((item) => {
      const obj = item;
      if (!idList.includes(obj.id_cobertura)) {
        obj.eliminado = true;
        return obj;
      }
      // obj.editado = true;
      return obj;
    }); */

    toUpdateControlProducto.cPC = updatedCoberturasList;
    setControlProducto(toUpdateControlProducto);

    // Actualizar Control Producto List
    const newDataList = controlProductoList.map((item) => {
      if (
        (item.id &&
          toUpdateControlProducto.id &&
          item.id === toUpdateControlProducto.id) ||
        (item.row &&
          toUpdateControlProducto.row &&
          item.row === toUpdateControlProducto.row)
      ) {
        return toUpdateControlProducto;
      }
      return item;
    });
    if (!toUpdateControlProducto.eliminado) {
      setControlProductoList(newDataList);
      setList(newDataList);
    } else {
      setControlProductoList(newDataList);
      // setList(newDataList);
      setControlProductoEliminadoList([
        ...controlProductoEliminadoList,
        toUpdateControlProducto
      ]);
    }
  };

  const handleChangeFranquicias = (values, record) => {
    const controlProductoConFranquicias = {
      ...record,
      franquicia_config: values.franquicia_config,
      franquicias: values.franquicias
    };
    setControlProducto(controlProductoConFranquicias);
    setOpenFranquiciaRangos(false);
  };

  useEffect(() => {
    if (controlProducto) {
      const newDataList = controlProductoList.map((item) => {
        if (
          (item.id && controlProducto.id && item.id === controlProducto.id) ||
          (item.row && controlProducto.row && item.row === controlProducto.row)
        ) {
          return controlProducto;
        }
        return item;
      });
      if (!controlProducto.eliminado) {
        setControlProductoList(newDataList);
        setList(newDataList);
      } else {
        setControlProductoList(newDataList);
        // setList(newDataList);
        setControlProductoEliminadoList([
          ...controlProductoEliminadoList,
          controlProducto
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlProducto]);

  useEffect(() => {
    if (list) {
      const listWithRow = [];
      for (let i = 0; i < list.length; i += 1) {
        const element = list[i];
        element.row = i + 1;
        listWithRow.push(element);
      }
      setControlProductoList(listWithRow);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);
  useEffect(() => {
    if (idProducto) {
      getMonedas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProducto]);

  const initializeFranquiciasModel = useCallback(
    (record) => {
      if (!franquiciasModel && monedaList) {
        const newFranquiciasModel = {
          producto,
          moneda: monedaList.find((item) => item.codigo === 'gs'),
          franquicias: record?.franquicias || []
        };
        setFranquiciasModel(newFranquiciasModel);
      }
      setOpenFranquiciaRangos(true);
    },
    [producto, monedaList, franquiciasModel, setFranquiciasModel]
  );

  return (
    <>
      <Button
        onClick={handleAddRow || handleAdd}
        type="primary"
        style={{ marginBottom: 16 }}
      >
        Agregar
      </Button>
      {((controlProductoList && controlProductoList.length > 0) ||
        dataSourceTable) && (
        <>
          <Table
            fixed
            scroll
            style={{ width: '100%' }}
            bordered
            dataSource={
              dataSourceTable ||
              controlProductoList.filter((item) => !item.eliminado)
            }
            columns={columns || columnsVehiculoZona}
            pagination
            size="large"
            rowKey={(record) =>
              `${
                record && (record.id || record.row)
              }-tipo-${Math.random().toString(36).substr(2, 9)}`
            }
          />
        </>
      )}
    </>
  );
};

const ControlProductoModal = ({
  tipoValidacion,
  idAutorizacionConfig,
  autorizacionConfig,
  controlProductoList,
  setControlProductoList,
  idAseguradora,
  idProducto,
  loading,
  setLoading,
  open,
  setOpen,
  mostrarAcciones,
  update,
  columns,
  dataSourceTable,
  handleAddRow,
  handleConfirm,
  producto
}) => {
  const [isModalOpen, setIsModalOpen] = useState(open || false);
  const [list, setList] = useState([]);
  const [
    controlProductoEliminadoList,
    setControlProductoEliminadoList
  ] = useState([]);

  const showModal = () => {
    if (open !== undefined) {
      setOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };
  const handleOk = async () => {
    const messageValidation = validarNewControlProductoList(list);
    if (!messageValidation || !mostrarAcciones) {
      const unifiedList = list.map((item) => {
        const eliminadoItem = controlProductoEliminadoList.find(
          (elimItem) => elimItem.id === item.id
        );
        if (eliminadoItem && eliminadoItem.eliminado) {
          return { ...item, eliminado: true };
        }
        return item;
      });

      setControlProductoList([...unifiedList]);
      // eslint-disable-next-line no-param-reassign
      autorizacionConfig[0].editado = true;
      await update(autorizacionConfig, [...unifiedList]);
      if (open !== undefined) {
        setOpen(false);
      } else {
        setIsModalOpen(false);
      }
    } else {
      message.warning(messageValidation);
    }
  };
  const handleCancel = () => {
    // setList(controlProductoList);
    // setControlProductoList([]);
    if (open !== undefined) {
      setOpen(false);
    } else {
      setIsModalOpen(false);
    }
  };

  const validarNewControlProductoList = (lista) => {
    let messageVal = null;
    for (let i = 0; i < lista.length; i += 1) {
      const controlProducto = lista[i];
      if (!controlProducto.eliminado) {
        if (!controlProducto.recargo && !controlProducto.autorizacion) {
          if (!idAseguradora) {
            messageVal =
              'Es obligatorio agregar por lo menos un control de Autorización o Recargo';
          } else if (
            idAseguradora &&
            (!controlProducto.cPC || controlProducto.cPC.length === 0)
          ) {
            messageVal =
              'Es obligatorio agregar por lo menos un control de Autorización, Recargo o Coberturas';
          }
        }
      }
    }

    return messageVal;
  };
  useEffect(() => {
    setList(controlProductoList);
  }, [controlProductoList]);

  useEffect(() => {
    if (open !== undefined) {
      setIsModalOpen(open);
    }
  }, [open]);

  return (
    <>
      {open === undefined && (
        <Tooltip title="Control Producto">
          <Button
            icon={<FileProtectOutlined />}
            type="text"
            size="middle"
            onClick={showModal}
          />
        </Tooltip>
      )}

      <Modal
        title="Lista de Control Producto"
        open={isModalOpen}
        onOk={handleConfirm || handleOk}
        onCancel={handleCancel}
        width={1500}
        closable={false}
      >
        {/* <Spin spinning={loading} delay={500} size="large" tip="Cargando..."> */}
        <ControlProductoList
          tipoValidacion={tipoValidacion}
          list={list}
          setList={setList}
          idAutorizacionConfig={idAutorizacionConfig}
          idAseguradora={idAseguradora}
          idProducto={idProducto}
          loading={loading}
          setLoading={setLoading}
          mostrarAcciones={mostrarAcciones}
          {...{
            controlProductoEliminadoList,
            setControlProductoEliminadoList
          }}
          columns={columns}
          dataSourceTable={dataSourceTable}
          handleAddRow={handleAddRow}
          producto={producto}
        />
        {/* </Spin> */}
      </Modal>
    </>
  );
};
export default ControlProductoModal;
